"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.columnsMeta = void 0;
const footerLinks = {
  MAIN_SITE: "https://singularitynet.io/",
  CONTACT_US: "https://singularitynet.io/contact/",
  PRIVACY_POLICY: "https://public.singularitynet.io/privacy_policy.html",
  AI_MARKETPLACE: "https://beta.singularitynet.io",
  AGI_STAKING: "https://staking.singularitynet.io",
  AI_PUBLISHER: "https://publisher.singularitynet.io/",
  DEVELOPER_PORTAL: "https://dev.singularitynet.io/",
  BLOG: "https://blog.singularitynet.io/",
  DOCUMENTATION: "https://singularitynet.gitbook.io/welcome-to-gitbook/",
  FORUM: "https://community.singularitynet.io/",
  TELEGRAM: "https://telegram.me/singularitynet",
  SDAO: "https://singularitydao.ai/",
  REJUVE: "https://rejuve.ai/",
  NUNET: "https://nunet.io/",
  TWITTER: "https://twitter.com/singularity_net",
  FACEBOOK: "https://www.facebook.com/singularityNET.io",
  LINKED_IN: "https://www.linkedin.com/company/singularitynet/",
  YOU_TUBE: "https://www.youtube.com/channel/UCbTE8vfz5zuEK5uRnc2yjrw",
  INSTAGRAM: "https://instagram.com/singularitynet.io"
};
const columnsMeta = exports.columnsMeta = [{
  key: 0,
  isPrimary: true,
  title: "SingularityNet",
  links: [{
    key: 0,
    label: "Contact Us",
    href: footerLinks.CONTACT_US
  }, {
    key: 1,
    label: "PrivacyPolicy",
    href: footerLinks.PRIVACY_POLICY
  }, {
    key: 2,
    label: "Foundation Main Site",
    href: footerLinks.MAIN_SITE
  }]
}, {
  key: 1,
  isPrimary: false,
  title: "Products",
  links: [{
    key: 0,
    label: "AI Marketplace",
    href: footerLinks.AI_MARKETPLACE
  }, {
    key: 1,
    label: "AGIX Staking",
    href: footerLinks.AGI_STAKING
  }, {
    key: 2,
    label: "AI publisher",
    href: footerLinks.AI_PUBLISHER
  }, {
    key: 3,
    label: "Developer Portal",
    href: footerLinks.DEVELOPER_PORTAL
  }]
}, {
  key: 2,
  isPrimary: false,
  title: "Community",
  links: [{
    key: 0,
    label: "Official Blog",
    href: footerLinks.BLOG
  }, {
    key: 1,
    label: "Documentation",
    href: footerLinks.DOCUMENTATION
  }, {
    key: 2,
    label: "Forum",
    href: footerLinks.FORUM
  }, {
    key: 3,
    label: "Telegram",
    href: footerLinks.TELEGRAM
  }]
}, {
  key: 3,
  isPrimary: false,
  title: "Ecosystem",
  links: [{
    key: 0,
    label: "Singularity DAO",
    href: footerLinks.SDAO
  }, {
    key: 1,
    label: "Rejuve",
    href: footerLinks.REJUVE
  }, {
    key: 2,
    label: "Nunet",
    href: footerLinks.NUNET
  }]
}, {
  key: 4,
  isPrimary: false,
  title: "Social Media",
  links: [{
    key: 0,
    label: "Twitter",
    href: footerLinks.TWITTER
  }, {
    key: 1,
    label: "Facebook",
    href: footerLinks.FACEBOOK
  }, {
    key: 2,
    label: "LinkedIn",
    href: footerLinks.LINKED_IN
  }, {
    key: 3,
    label: "YouTube",
    href: footerLinks.YOU_TUBE
  }, {
    key: 4,
    label: "Instagram",
    href: footerLinks.INSTAGRAM
  }]
}];